import React, {ChangeEvent, DragEvent, useRef, useState} from 'react';

interface ImageUploaderProps {
    initialSrc?: string;
    onFileSelect: (file: File) => void;
    width: any;
    height: any;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({initialSrc, onFileSelect, width, height}) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [isDragOver, setIsDragOver] = useState<boolean>(false);
    
    // Load initialSrc into selectedImage when component mounts
    React.useEffect(() => {
        if (initialSrc) {
            setSelectedImage(initialSrc);
        }
    }, [initialSrc]);
    
    const onDragOver = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setIsDragOver(true);
    };
    
    const onDragLeave = () => {
        setIsDragOver(false);
    };
    
    const onDrop = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setIsDragOver(false); // Reset drag over style
        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
            const file = event.dataTransfer.files[0];
            updateImage(file);
            onFileSelect(file);
        }
    };
    
    const updateImage = (file: File) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result as string);
        };
        reader.readAsDataURL(file);
    };
    
    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            updateImage(file);
            onFileSelect(file);
        }
    };
    
    const triggerFileSelect = () => fileInputRef.current?.click();
    
    const renderContent = () => {
        if (selectedImage) {
            return <img src={selectedImage} alt="Selected" style={{width: '100%', height: '100%', objectFit: "contain"}}/>;
        } else {
            return (
                <div style={{padding: '20px'}}>
                    <i className="display-4 text-muted bx bx-cloud-upload"/>
                    <p>Drop image here, <br/>or Upload</p>
                </div>
            );
        }
    };
    
    return (
        <div
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            onClick={triggerFileSelect}
            style={{
                border: '1px dashed gray',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: isDragOver ? '#e9e9e9' : 'transparent', // Change color on drag over
                width: width,
                height: height,
            }}
        >
            {renderContent()}
            <input type="file" onChange={onChange} ref={fileInputRef} style={{display: 'none'}}
                   accept=".jpg,.jpeg,.png"/>
        </div>
    );
};

export default ImageUploader;
